export enum LOG_ACTION {
  CHANGE_ORDER_STATUS = 'change_order_status',
  CALLBACK_SAFE2PAY = 'callback_safe2pay',
}
